import { useState } from "react";
import { X } from "lucide-react";
import { adminApi } from "../../api";

export default function PrecarioCreateModal({ existingItems, onClose, onCreated }) {
  const yearNow = new Date().getFullYear();
  const [form, setForm] = useState({
    ano: yearNow + 1,
    nome: `Preçário ${yearNow + 1}`,
    valido_de: `${yearNow + 1}-01-01`,
    valido_ate: `${yearNow + 1}-12-31`,
    iva_pct: 23,
    notas: "",
    activo: "N",
    clone_from_id: existingItems?.[0]?.ID_Precario || null,
  });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr(null);
    try {
      const r = await adminApi.precarioCreate({
        ano: Number(form.ano),
        nome: form.nome,
        valido_de: form.valido_de || null,
        valido_ate: form.valido_ate || null,
        iva_pct: Number(form.iva_pct),
        notas: form.notas || null,
        activo: form.activo,
        clone_from_id: form.clone_from_id ? Number(form.clone_from_id) : null,
      });
      if (r.success) onCreated(r.id_precario);
      else setErr("Falha a criar preçário.");
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" data-testid="precario-create-modal">
      <div className="bg-white rounded-md shadow-xl w-full max-w-lg">
        <div className="px-5 py-3 border-b border-[#F3F0E7] flex items-center justify-between">
          <h3 className="text-sm font-bold uppercase tracking-[0.12em]">Novo preçário</h3>
          <button onClick={onClose} className="text-[#978D78] hover:text-[#0F1829]" data-testid="precario-create-close"><X size={16} /></button>
        </div>
        <form onSubmit={submit} className="p-5 space-y-3 text-sm">
          <div className="grid grid-cols-2 gap-3">
            <label className="flex flex-col gap-1">
              <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Ano</span>
              <input type="number" required value={form.ano} onChange={(e) => update("ano", e.target.value)}
                className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-ano" />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">IVA %</span>
              <input type="number" step="0.01" required value={form.iva_pct} onChange={(e) => update("iva_pct", e.target.value)}
                className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-iva" />
            </label>
          </div>
          <label className="flex flex-col gap-1">
            <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Nome</span>
            <input required value={form.nome} onChange={(e) => update("nome", e.target.value)}
              className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-nome" />
          </label>
          <div className="grid grid-cols-2 gap-3">
            <label className="flex flex-col gap-1">
              <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Válido de</span>
              <input type="date" value={form.valido_de} onChange={(e) => update("valido_de", e.target.value)}
                className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-de" />
            </label>
            <label className="flex flex-col gap-1">
              <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Válido até</span>
              <input type="date" value={form.valido_ate} onChange={(e) => update("valido_ate", e.target.value)}
                className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-ate" />
            </label>
          </div>
          <label className="flex flex-col gap-1">
            <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Notas</span>
            <textarea rows={2} value={form.notas} onChange={(e) => update("notas", e.target.value)}
              className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-notas" />
          </label>
          <label className="flex flex-col gap-1">
            <span className="text-[11px] uppercase tracking-[0.12em] text-[#978D78] font-bold">Clonar items+descontos de</span>
            <select value={form.clone_from_id || ""} onChange={(e) => update("clone_from_id", e.target.value || null)}
              className="border border-[#E6E1D6] rounded px-2 py-1.5 text-sm" data-testid="precario-create-clone">
              <option value="">— Não clonar (vazio) —</option>
              {existingItems?.map((p) => (
                <option key={p.ID_Precario} value={p.ID_Precario}>{`${p.Ano} · ${p.Nome} (${p.NumItems} items)`}</option>
              ))}
            </select>
          </label>
          <label className="flex items-center gap-2 text-xs text-[#4B5563]">
            <input type="checkbox" checked={form.activo === "S"} onChange={(e) => update("activo", e.target.checked ? "S" : "N")} data-testid="precario-create-activo" />
            <span>Activar imediatamente (desactiva outros do mesmo ano)</span>
          </label>

          {err && <p className="text-red-600 text-xs" data-testid="precario-create-error">{err}</p>}

          <div className="flex items-center justify-end gap-2 pt-2 border-t border-[#F3F0E7]">
            <button type="button" onClick={onClose} className="px-3 py-1.5 text-xs border border-[#E6E1D6] rounded hover:bg-[#FAF8F2]" data-testid="precario-create-cancel">Cancelar</button>
            <button type="submit" disabled={busy} className="px-3 py-1.5 text-xs font-bold uppercase tracking-wider bg-[#0F1829] text-white rounded hover:bg-black disabled:opacity-40" data-testid="precario-create-submit">
              {busy ? "A criar..." : "Criar"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
